module.exports = __webpack_public_path__ + "static/img/cnt-text.7d1cbcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/worldview/cnt-text.png
// module id = IeTC
// module chunks = 1